import { render, staticRenderFns } from "./GridColumn.vue?vue&type=template&id=d588adee&scoped=true&"
import script from "./GridColumn.vue?vue&type=script&lang=js&"
export * from "./GridColumn.vue?vue&type=script&lang=js&"
import style0 from "./GridColumn.vue?vue&type=style&index=0&id=d588adee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d588adee",
  null
  
)

export default component.exports